import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import StudentPerformanceComp from './StudentPerformanceComp'

function StudentPerformance() {
  return (
    <div>
      <div className='mainContainer'>
        <Leftmenu/>
        <div className='theMainContainer'>
          <Dashnav/>
              <AdmissionTopNotice/>
          <StudentPerformanceComp/>
        </div>
      </div>
    </div>
  )
}

export default StudentPerformance
